import React from 'react';
import PropTypes from 'prop-types';
import _find from 'lodash/find';

import { QueryComponent } from '../../../../GraphQL';
import { getMyMockExamResults, MASTER_EXAM_STATUS } from '../../../../GraphQL/query/MockExam.query';

import RecommendedCourses from './RecommendedCourses';

const flattenArray = (array, field) => {
  const reducer = (acc, currentValue) => {
    return [...acc, currentValue[field]];
  };
  const newArray = Array.isArray(array) ? array.reduce(reducer, []) : [];
  return newArray;
};

const getRow = (data, examCard) => {
  const examId = examCard.examId;
  const exam = examCard.exam;
  const examResult = _find(data.mockExamResults, d => d.examId === examId) || {};
  const myExamResult = _find(data.myMockExamResults, d => d.examId === examId) || {};

  return {
    id: examId,
    subjectCode: exam.subjectCode,
    averageScore: examResult.averageScore,
    fullScore: examResult.fullScore,
    score: myExamResult.score,
    ranking: myExamResult.rank,
    percentile: myExamResult.percentile,
    examCardId: examCard.id,
  };
};

const RecommendedCoursesQuery = ({ title, examCards, ...restProps }) => {
  const resultReadyCards = examCards.filter(
    card => card.exam.status === MASTER_EXAM_STATUS.GRADE_READY,
  );
  const examCardIds = flattenArray(resultReadyCards, 'id');
  const mockExamIds = flattenArray(resultReadyCards, 'examId');
  return (
    <QueryComponent query={getMyMockExamResults} variables={{ examCardIds, mockExamIds }}>
      {data => {
        const rows = examCards.map(examCard => getRow(data, examCard));
        return <RecommendedCourses data={rows} {...restProps} />;
      }}
    </QueryComponent>
  );
};

RecommendedCoursesQuery.propTypes = {
  examCardIds: PropTypes.array,
};

export default RecommendedCoursesQuery;
